"use client";

import React from "react";
import { Search, Sparkles } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Link } from "@/components/common/Link";
export default function CraftingUnforgettableMemories() {
  return <section data-section-id="224501" id="crafting-unforgettable-memories" className="bg-background text-foreground relative w-full min-h-[80vh] flex items-center justify-center overflow-hidden py-24 lg:py-32">
      {}
      <div className="absolute inset-0 z-0 overflow-hidden pointer-events-none">
        <div className="absolute inset-0 bg-gradient-to-b from-primary/20 via-background/50 to-background z-10" />
        <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1687098/img/lavender_ballroom_ambiance.png" alt="Elegant ballroom atmosphere" className="w-full h-full object-cover opacity-20 scale-110 animate-[pulse_8s_ease-in-out_infinite] mix-blend-multiply" />
        {}
        <div className="absolute inset-0 bg-[radial-gradient(circle_at_center,transparent_0%,var(--background)_100%)] z-10" />
      </div>

      {}
      <div className="relative z-20 container mx-auto px-4 flex flex-col items-center text-center max-w-5xl">
        {}
        <div className="inline-flex items-center gap-2 px-3 py-1 rounded-md bg-white/40 border border-secondary backdrop-blur-md mb-8">
          <Sparkles className="w-4 h-4 text-primary" />
          <span className="text-sm font-default font-medium text-primary tracking-widest uppercase">
            Crafting Unforgettable Memories
          </span>
        </div>

        {}
        <h1 className="text-5xl sm:text-6xl md:text-7xl lg:text-8xl font-serif font-bold tracking-tight mb-8 leading-[1.1]">
          <span className="bg-gradient-to-br from-primary via-primary/80 to-secondary-foreground bg-clip-text text-transparent">
            Signature
          </span>
          <br />
          <span className="bg-gradient-to-br from-secondary-foreground to-primary/60 bg-clip-text text-transparent">
            Occasions
          </span>
        </h1>

        {}
        <div className="w-full max-w-2xl relative mb-12 group">
          <div className="absolute -inset-1 bg-gradient-to-r from-secondary to-primary/20 rounded-md blur opacity-30 group-hover:opacity-50 transition duration-500"></div>
          <div className="relative flex items-center">
            <Search className="absolute left-6 w-6 h-6 text-muted-foreground z-10" />
            <Input type="text" placeholder="Search our event services..." className="w-full h-16 sm:h-18 pl-16 pr-36 rounded-md bg-white/60 border-secondary backdrop-blur-xl text-lg text-foreground placeholder:text-muted-foreground focus-visible:ring-primary focus-visible:border-primary transition-all shadow-md" />
            <div className="absolute right-2 top-2 bottom-2">
              <Button size="lg" className="h-full rounded-md px-8 bg-primary text-primary-foreground hover:bg-primary/90 font-default font-semibold text-base shadow-md">
                Search
              </Button>
            </div>
          </div>
        </div>

        {}
        <div className="flex flex-col sm:flex-row items-center gap-4 sm:gap-6">
          <Button asChild size="lg" className="w-full sm:w-auto rounded-md px-8 h-14 text-base font-default font-semibold bg-primary text-primary-foreground hover:bg-primary/90 shadow-lg transition-all duration-300">
            <Link to="/PortfolioPage">The Portfolio</Link>
          </Button>
          <Button asChild variant="outline" size="lg" className="w-full sm:w-auto rounded-md px-8 h-14 text-base font-default font-semibold border-secondary bg-white/20 hover:bg-secondary/30 text-primary backdrop-blur-md transition-all duration-300">
            <Link to="/LetsTalkPage">Book a Consultation</Link>
          </Button>
        </div>

        {}
        <div className="mt-16 pt-8 border-t border-secondary/50 flex flex-wrap justify-center gap-8 text-sm text-muted-foreground font-default font-medium tracking-wide">
          <div className="flex items-center gap-2">
            <div className="w-2 h-2 rounded-md bg-primary"></div>
            Bespoke Wedding Planning
          </div>
          <div className="flex items-center gap-2">
            <div className="w-2 h-2 rounded-md bg-secondary-foreground"></div>
            Corporate Excellence
          </div>
          <div className="flex items-center gap-2">
            <div className="w-2 h-2 rounded-md bg-accent-foreground"></div>
            Luxury Event Design
          </div>
        </div>
      </div>
    </section>;
}